import { MenuItem } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { BulkRestoreActionProps, useBulkRestore } from "./useBulkRestore";
import { BulkRestoreConfirmationModal } from "./BulkRestoreConfirmationModal";

/**
 * Menu item for bulk restoring entries from the recycle bin
 * @data-endpoint recyclebin-recycle-bin-ds-restore
 */
export const BulkRestoreMenuItem = ({ entryIds, reloadMedia, apiUrl }: BulkRestoreActionProps) => {
    const { selectedCount, openConfirmation, processing, handleClick, handleRestore, closeConfirmation } =
        useBulkRestore({ entryIds, reloadMedia, apiUrl });

    return (
        <>
            <MenuItem onClick={handleClick}>{translate("Restore")}</MenuItem>

            <BulkRestoreConfirmationModal
                open={openConfirmation}
                processing={processing}
                selectedCount={selectedCount}
                onClose={closeConfirmation}
                onConfirm={handleRestore}
            />
        </>
    );
};

export default BulkRestoreMenuItem;
